import { gql } from '@apollo/client'
import { PHYSICAL_STORE_FRAGMENT } from '../fragments'

export const GET_PHYSICAL_STORES = gql`
  query GetPhysicalStores($input: StoresInput!) {
    stores(input: $input) {
      count
      hasMore
      results {
        ...PhysicalStore
      }
    }
  }
  ${PHYSICAL_STORE_FRAGMENT}
`
